export default {
  predictiveRouting: [],
  status: {},
  references: [],
};